<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">{{ $t("Grupos do SCFV") }}</h1>

    <b-card class="shadow">
      <div class="row animate__animated animate__fadeIn" v-if="!novo_grupo">
        <div class="col-12">
          <div class="d-flex flex-column">
            <div class="d-flex align-items-center justify-content-between">
              <div class="mr-auto">
                <button class="btn btn-sm btn-primary" @click="novo_grupo = true">
                  <i class="fas fa-plus-square" />
                  {{ $t("Cadastrar") }}
                </button>
              </div>
              <div>
                <b-button-group>
                  <b-button
                      variant="outline-dark"
                      class="btn btn-default py-2 mb-3"
                      @click="viewFilters"
                    >
                      <i class="fas fa-filter"></i>
                      {{ $t("Filtros") }}
                  </b-button>
                  <router-link
                    class="btn btn-default py-2 mb-3"
                    to="/dashboard/relatorios/scfv"
                  >
                    <i class="fas fa-chart-bar"></i>
                    {{ $t("Relatórios") }}
                  </router-link>
                  <b-button
                    v-if="this.$store.state.user.role == '1'"
                    :title="$t('Importar do SISC')"
                    v-b-modal.modalImportarSisc
                    class="py-2 mb-3"
                    size="sm"
                    type="button"
                    v-b-tooltip.hover
                    variant="default"
                  >
                    <i class="fas fa-file-upload"></i>
                    {{ $t("Importar do SISC") }}
                  </b-button>
                  <b-button
                    :title="$t('Exportar')"
                    @click="exportar"
                    class="py-2 mb-3"
                    size="sm"
                    type="button"
                    v-b-tooltip.hover
                    variant="default"
                  >
                    <i class="fas fa-file-download"></i>
                    {{ $t("Exportar") }}
                  </b-button>
                </b-button-group>
              </div>
              <div>
                <div class="input-group mb-3">
                  <b-input
                    :placeholder="$t('Type to search')"
                    class="form-control search-input"
                    type="text"
                    v-model="search"
                    v-on:change="getItens"
                    aria-describedby="input-search"
                  />
                  <div class="input-group-append" role="button">
                    <span class="input-group-text" id="input-search"
                      ><i class="fas fa-search search-icon"
                    /></span>
                  </div>
                </div>
              </div>
            </div>
            <div>
                <div class="col-12" v-if="viewFilterReport">
                <!-- Filtros -->
                <form @submit.prevent="getItens" ref="addItem">
                  <div class="row">
                    <form-select
                      v-model="filtroUnidade"
                      label="Unidade"
                      grid="4"
                      :itens="unidades"
                      :disabled="desabledSearchUnidade"
                      :loading="loadingSearchUnidade"
                    />

                  </div>
                  <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
                    <div class="col-auto px-2 text-right">
                      <button
                        class="btn btn-default"
                        @click.prevent="limparFiltros(), (viewFilterReport = false)"
                      >
                        <i class="fas fa-times"></i>
                      </button>

                      <button
                        type="button"
                        class="btn btn-secondary"
                        @click.prevent="limparFiltros()"
                      >
                        {{ $t("Limpar Filtros") }}
                      </button>

                      <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                        @click.prevent="getItens()"
                      >
                        <i class="fas fa-chart-bar"></i>
                        {{ $t("Gerar Relatório") }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
          />
          <print-content>
            <b-table
              :fields="[
                {
                  key: 'nome_grupo',
                  label: $t('Detalhes'),
                },
                {
                  key: 'cadastrado',
                  label: $t('Criado em'),
                },
                {
                  key: 'status',
                  label: $t('Status'),
                },
                {
                  key: 'actions',
                  label: '',
                  class: 'text-right no-print',
                  thStyle: { width: '95px', minWidth: '95px' },
                },
              ]"
              :items="itemList"
              :responsive="true"
              striped
              hover
              show-empty
              small
              outlined
              stacked="xs"
              table-class="mb-3"
            >
              <template v-slot:cell(nome_grupo)="data">
                Nome:
                <strong> {{ data.value }} </strong>
                <br />
                Faixa Etária:
                <strong> {{ data.item.faixa_etaria_nome }} </strong>

                <span class="d-block">
                  Inscritos:
                  <strong
                    >{{ data.item.inscritos.length }}/{{
                      data.item.numero_vagas
                    }}
                  </strong>
                  <b-link
                    href="#"
                    v-if="data.item.inscritos.length >= data.item.numero_vagas"
                    v-b-tooltip.hover
                    title="Atingiu limite de inscritos!"
                  >
                    <b-icon
                      icon="exclamation-triangle-fill"
                      variant="warning"
                      animation="fade"
                    ></b-icon>
                  </b-link>
                </span>

                Responsável:
                <strong>
                  <b-link :class="data.item.responsavel ? '' : 'text-danger'">
                    {{
                      data.item.responsavel
                        ? data.item.responsavel.nome
                        : "Sem Responsável"
                    }}
                  </b-link>
                </strong>
                -
                <span>{{
                  data.item.responsavel.profissao ?? "Não informado"
                }}</span>
                <br />
                Protocolo:
                <strong> {{ data.item.protocolo }} </strong>
              </template>
              <template v-slot:cell(cadastrado)="data">
                <strong>{{ data.value }}</strong>
              </template>
              <template v-slot:cell(status)="data">
                <span v-html="data.item.status_nome"></span>
              </template>

              <template v-slot:cell()="data">
                <b-button
                  :title="$t('Editar')"
                  :to="'/dashboard/scfv/edit/' + data.item.id"
                  class="px-2 mb-0"
                  size="xs"
                  type="button"
                  v-b-tooltip.hover
                  variant="success"
                  v-if="verificaPermissao(data.item)"
                >
                  <i class="mdi mdi-square-edit-outline" />
                </b-button>

                <b-button
                  v-if="
                    $store.state.user.role_details.name == 'Coordenador' ||
                    $store.state.user.role_details.name == 'Gestor(a)' ||
                    $store.state.user.role_details.name ==
                      'Técnico(a) de Nível Superior' ||
                    user_id == data.item.responsavel.id ||
                    user_id == data.item.facilitador_id ||
                    user_id == data.item.tecnico_id ||
                    user_id == data.item.orientador_id
                  "
                  :title="$t('Visualizar e Imprimir')"
                  :to="'/dashboard/scfv/show/' + data.item.id"
                  class="px-2 mb-0"
                  size="xs"
                  type="button"
                  v-b-tooltip.hover
                  variant="primary"
                >
                  <i class="mdi mdi-eye" />
                </b-button>
              </template>
              <template v-slot:empty="scope">
                <div class="text-center my-5">
                  <img
                    :alt="$t('No results')"
                    class="mb-5"
                    src="/img/icons/robot.svg"
                    style="max-height: 165px"
                  />
                  <h3 class="bold">
                    {{ $t("No records found") }}
                  </h3>
                </div>
              </template>
            </b-table>
          </print-content>
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
              <div class="form-group d-inline-flex mb-0">
                <select
                  class="form-control"
                  style="width: 70px"
                  v-model="perPage"
                  v-on:change="getItens"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
              </div>
              <div class="d-inline-flex ml-2">
                <b-pagination
                  :per-page="perPage"
                  :total-rows="pagination.total"
                  @change="changePage"
                  v-model="page"
                />
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
              <div class="float-lg-right">
                {{ $t("Showing page") }}
                {{ pagination.currentPage }}
                {{ $t("of") }}
                {{ pagination.totalPages }}
                {{ $t("pages in") }}
                {{ pagination.total }}
                {{ $t("records") }}
              </div>
            </div>
          </div>
        </div>
        <div class="box-btn-print no-print">
          <b-button
            v-if="!loading"
            :title="$t('Visualizar e Imprimir')"
            class="py-2"
            size="sm"
            type="button"
            v-b-tooltip.hover
            variant="primary"
            @click="print()"
          >
            <i class="fas fa-print"></i>
          </b-button>
        </div>
      </div>

      <NovoGrupo v-else @voltar="novo_grupo = false" />
    </b-card>

    <ModalImportarSisc />
  </div>
</template>

<script>
import NovoGrupo from "./Add";
import ModalImportarSisc from "./includes/ModalImportarGrupo";

export default {
  components: { NovoGrupo, ModalImportarSisc },
  name: "SCFV",
  metaInfo() {
    return {
      title: this.$i18n.t("Grupos SCFV"),
    };
  },
  data() {
    return {
      novo_grupo: false,
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      itemList: [],
      participantes: [],
      filtro: null,
      user_id: null,
      role_id: null,
      tecnico_id: null,
      unidades: [],
      filtroUnidade: null,
      loadingSearchUnidade: true,
      desabledSearchUnidade: true,
    };
  },
  mounted() {
    this.getItens();
    this.getUnidades();
    //console.log('Permissao', this.$store.state.user.role);
    
  },
  methods: {
    verificaPermissao(data) {
      const user = this.$store.state.user;
      const isCoordenadorDaUnidade =
        user.role_details &&
        user.role_details.name == "Coordenador" &&
        user.tecnico &&
        user.tecnico.unidade_id == data.unidade_id;

      return (
        isCoordenadorDaUnidade ||
        this.user_id == data.user_id ||
        this.tecnico_id == data.tecnico_id ||
        this.tecnico_id == data.orientador_id ||
        this.tecnico_id == data.facilitador_id ||
        this.isTecnicoParticipante(data.tecnicos)
      );
    },
    isTecnicoParticipante(tecnicos) {
      let user_logado = this.$store.state.user.tecnico.id;
      let is_tecnico = false;
      if (Array.isArray(tecnicos)) {
        tecnicos.forEach((id) => {
          if (id == user_logado) {
            is_tecnico = true;
          }
        });
      }
      return is_tecnico;
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getItens();
      }
    },
    exportar() {
      this.isLoading = true;
      swal.fire({
        title: "Aguarde",
        text: "O Arquivo está sendo gerado.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/scfv", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            export: "ok",
          },
        })
        .then((response) => {
          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => (this.isLoading = false));
    },
    getItens() {
      this.loading = true;
      axios
        .get("api/dashboard/scfv", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroUnidade: this.filtroUnidade,
          },
        })
        .then((response) => {
          this.user_id = this.$store.state.user.id;
          this.tecnico_id = this.$store.state.user.tecnico.id;
          this.itemList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getItens();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getUnidades() {
      this.loadingSearchUnidade = true;
      this.desabledSearchUnidade = true;
      axios
        .get(`api/dashboard/unidades/get/externas`)
        .then((response) => {
          this.unidades = response.data;
        })
        .finally(() => {
          this.loadingSearchUnidade = false;
          this.desabledSearchUnidade = false;
        });
    },
    limparFiltros() {
      this.filtroUnidade = null;
      this.getItens();
    },
    printMe() {
      //   const quality = 1;
      //   html2canvas(document.getElementById("printme"), { scale: quality })
      //     .then((canvas) => {
      //       let imgData = canvas.toDataURL("image/png");
      //       let imgWidth = 210; // Largura em mm de um a4
      //       let pageHeight = 297; // Altura em mm de um a4
      //       let imgHeight = (canvas.height * imgWidth) / canvas.width;
      //       let heightLeft = imgHeight;
      //       let position = 10;
      //       let pdf = new jsPDF("p", "mm");
      //       let fix_imgWidth = 15; // Vai subindo e descendo esses valores ate ficar como queres
      //       let fix_imgHeight = 15; // Vai subindo e descendo esses valores ate ficar como queres
      //       pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      //       heightLeft -= pageHeight;
      //       while (heightLeft >= 0) {
      //         position = heightLeft - imgHeight;
      //         pdf.addPage();
      //         pdf.addImage(
      //           imgData,
      //           "PNG",
      //           0,
      //           position,
      //           imgWidth + fix_imgWidth,
      //           imgHeight + fix_imgHeight
      //         );
      //         heightLeft -= pageHeight;
      //       }
      //       pdf.save("sample-file.pdf");
      //     })
      //     .catch(function (e) {
      //       //console.log(e.message);
      //     });
    },
  },
};
</script>
